import loadCadesplugin from '@/common/helpers/signer/cadesplugin_api'

async function * promiseIterator(promises) {
  let indexedPromises = promises.map(
    (promise, index) => new Promise(resolve => promise.then(
      result => resolve({ result, index })
    ))
  )
  indexedPromises = new Map(indexedPromises.map(
    (indexedPromise, index) => [index, indexedPromise])
  )
  while (indexedPromises.size !== 0) {
    try {
      const indexedPromise = await Promise.any(indexedPromises.values())
      indexedPromises.delete(indexedPromise.index)

      yield indexedPromise.result

    } catch (error) {
      return
    }

  }
}

export async function * certificatesIterator() {
  loadCadesplugin()
  const cadesplugin = window.cadesplugin
  await cadesplugin
  const stores = [
    new Promise((resolve, reject) => cadesplugin.CreateObjectAsync('CAdESCOM.Store')
      .then(store => store.Open()
        .then(() => resolve(store))
        .catch(reject)
      )
    ),
    new Promise((resolve, reject) => cadesplugin.CreateObjectAsync('CAdESCOM.Store')
      .then(store => store.Open(cadesplugin.CADESCOM_CONTAINER_STORE)
        .then(() => resolve(store))
        .catch(reject)
      )
    )
  ]
  const thumbprints = []
  for await (const store of promiseIterator(stores)) {
    const CertificatesObj = await store.Certificates
    const certCnt = await CertificatesObj.Count
    const certificates = []
    for (let i = 1; i <= certCnt; i++) {
      certificates.push(CertificatesObj.Item(i))
    }
    for await (const certificate of promiseIterator(certificates)) {
      const thumbprint = await certificate.Thumbprint
      if (!thumbprints.includes(thumbprint)) {
        thumbprints.push(thumbprint)

        yield certificate
      }
    }
    await store.Close()
  }
}
